export const PRODUCT_TEST_TYPE = {
  ADMISSION_TEST: 0,
  SURVEILLANCE_TEST: 1,
  PENALITY_TEST: 2,
  CHALLENGE_PROCEDURE_TEST: 3,
  RECALCULATION_TEST: 4,
  WITNESS_TEST: 5,
  SELECTION_THROUGH_SOFTWARE: 6
};

export const CONTRACT_STATUS = {
  APPLICANT: 6,
  APPLICANT_EXPELL_REQUESTED: 7,
  PARTICIPANT: 8,
  PARTICIPANT_EXPELL_REQUESTED: 9,
  CLOSED: 10,
  ARCHIVED: 11,
  SUSPENDED: 12
};

export const RECOVER_UNIT_POSSIBILITY = {
  UNDEFINED: 0,
  NO: 1,
  YES: 2
};

export const productTestToPrioritize = (productTestTypeId, customerStatusId) => {
  return productTestTypeId === PRODUCT_TEST_TYPE.ADMISSION_TEST
    || customerStatusId === CONTRACT_STATUS.APPLICANT;
}